/** Roles that may browse team calendars and Gestão das Marcações by hierarchy (like Gestor). */

export function normalizeComercialRole(role?: string | null): string {
  return String(role || '').trim().toLowerCase();
}

export function isComercialGestaoHierarchyRole(role?: string | null): boolean {
  const raw = String(role || '').trim();
  const rl = normalizeComercialRole(raw);
  if (!rl) return false;

  if (
    [
      'Commercial Director',
      'Sales Team Lead',
      'Regional Manager',
      'Call Center Manager',
      'Call Center Team Lead',
    ].includes(raw)
  ) {
    return true;
  }
  if (rl.includes('call center manager') || rl.includes('call center team lead')) {
    return true;
  }
  if (/(instrutor|trainer|assistente\s*instrutor)/.test(rl)) {
    return true;
  }
  if (/(assistente\s+(?:de\s+)?gestor|assistant\s+manager)/.test(rl)) {
    return true;
  }
  if (rl === 'gestor' || rl.includes('gerente') || rl.includes('director')) {
    return true;
  }
  if (
    rl.includes('função gerente') ||
    rl.includes('commercial director') ||
    rl.includes('sales team lead') ||
    rl.includes('regional manager')
  ) {
    return true;
  }
  return false;
}

/** Gestor and above — may move marcações to/from Aguardar (excludes Instrutor, Assistente de Gestor). */
export function isGestorOrAboveComercial(opts: {
  role?: string | null;
  tenant?: string | null;
  isAdmin?: boolean;
}): boolean {
  if (opts.isAdmin) return true;
  const tenant = String(opts.tenant || '').toLowerCase();
  if (tenant === 'admin') return true;
  if (tenant && tenant !== 'comercial' && tenant !== 'commercial' && tenant !== 'ccc') {
    return false;
  }
  const raw = String(opts.role || '').trim();
  const rl = normalizeComercialRole(raw);
  if (
    [
      'Commercial Director',
      'Sales Team Lead',
      'Regional Manager',
      'Call Center Manager',
      'Gestor',
      'Gerente',
    ].includes(raw)
  ) {
    return true;
  }
  if (rl.includes('commercial director') || rl.includes('sales team lead') || rl.includes('regional manager')) {
    return true;
  }
  if (tenant === 'ccc' && (rl.includes('manager') || rl.includes('gerente') || rl.includes('director'))) {
    return true;
  }
  if (rl === 'gestor' || rl.includes('gerente') || rl.includes('director')) {
    return true;
  }
  return false;
}

export function canViewComercialTeamHierarchy(opts: {
  role?: string | null;
  tenant?: string | null;
  isAdmin?: boolean;
}): boolean {
  if (opts.isAdmin) return true;
  const tenant = String(opts.tenant || '').toLowerCase();
  if (tenant === 'admin') return true;
  if (tenant && tenant !== 'comercial' && tenant !== 'commercial' && tenant !== 'ccc') {
    return false;
  }
  return isComercialGestaoHierarchyRole(opts.role);
}
